<template>
    <Header></Header>

    <div id="presta-eligibility">
        <section class="main">
            <div class="search">
                <SinglePorteur @select="handlePorteurSelect"></SinglePorteur>
            </div>

            <div class="form">
                <Sub_PrestaEligibilityForm @form-data="checkEligibility" @reset-form="resetForm" :loading="loadingData" :prefill="porteurPrefill"></Sub_PrestaEligibilityForm>
            </div>
        </section>

        <section class="main" v-if="eligibility && !loadingData" id="eligibility-result">
            <Sub_PrestaEligibilityResponse :prestations="eligibility"></Sub_PrestaEligibilityResponse>
        </section>
    </div>
</template>

<script setup>
import { nextTick, ref }                from 'vue';
import Header                           from '@/components/Header.vue';
import Sub_PrestaEligibilityForm        from './Sub_PrestaEligibilityForm.vue';
import apiClient                        from '@/api';
import Sub_PrestaEligibilityResponse    from './Sub_PrestaEligibilityResponse.vue';
import SinglePorteur                    from '@/apps/RDV/SinglePorteur.vue';

const eligibility = ref(null)
const loadingData = ref(false)

const porteurPrefill = ref(null)

async function checkEligibility($event) {
    eligibility.value = null

    const start = Date.now()
    loadingData.value = true

    try {
        const response = await apiClient.post('/check_eligibility/', $event)
        eligibility.value = response.data
    } catch (e) {
        console.error(e)
    }

    loadingData.value = false
    await scrollToResult()

    const elapsedMs = Date.now() - start
    const seconds = Math.floor(elapsedMs / 1000)
    console.log(`Durée de la requête API : ${seconds}s`)
}

function resetForm() {
    eligibility.value = null
}

function handlePorteurSelect(porteur) {
    porteurPrefill.value = porteur
}

async function scrollToResult() {
    await nextTick()
    const element = document.getElementById('eligibility-result')
    if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
}
</script>

<style lang="scss" scoped>
#presta-eligibility {
    
    .main {
        margin-inline: auto;
        margin-block: 2rem;
        width: 60vw;

        background-color: #fff;
        border-radius: 15px;

        padding: 2rem;
    }

    .form {
        margin: auto;
        margin-top: 1rem;
    }

    .search {
        display: flex;
        justify-content: start;
        align-items: center;
        gap: 1rem;

        :deep(.controls) {
            flex-direction: row;
        }
    }
}

</style>